import { useState, useEffect } from 'react';

import { GVL } from '@iabtcf/core';
import gvl from '@module/consent-manager/gvl';

export function useConsentLanguage(language) {
  const [consentLanguage, setConsentLanguage] = useState({
    purposes: gvl.purposes,
    features: gvl.features,
  });

  useEffect(() => {
    async function changeLang() {
      let supportedLang = language;

      // IAB uses NO while WeTransfer users NB and they are both the same thing
      if (supportedLang === 'nb') {
        supportedLang = 'no';
      }

      // changeLanguage will fetch the language file provided by IAB but hosted
      // by us. GVL.baseUrl is the path where the language files are located.
      await gvl.changeLanguage(supportedLang);

      // We are deliberately using the GVL language cache to avoid race
      // conditions.
      const lang = GVL.LANGUAGE_CACHE.get(supportedLang.toUpperCase());

      setConsentLanguage(lang);
    }

    changeLang();
  }, [language]);

  return consentLanguage;
}
